import script from "./LoaderHyper.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderHyper.vue?vue&type=script&setup=true&lang=js"

import "./LoaderHyper.vue?vue&type=style&index=0&id=0f832d80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f832d80"]])

export default __exports__